import { ComponentProps, FC, isValidElement, ReactNode } from 'react';
import Linkify, { Props as LinkifyProps } from 'react-linkify';

const componentDecorator: LinkifyProps['componentDecorator'] = (href, text, key) => (
  <a href={href} key={key} target='_blank' rel='noreferrer'>
    {text}
  </a>
);

// Utility function to check if the value is a valid React child
const isValidChild = (child: ReactNode): boolean => {
  // React elements are valid
  if (isValidElement(child)) return true;

  // Strings and numbers are valid
  if (typeof child === 'string' || typeof child === 'number') return true;

  // Booleans while valid but don't render anything by default
  if (typeof child === 'boolean') return true;

  // `null` is valid but don't render anything by default
  // This check also catches `undefined` values which are only valid in React 18
  if (child == null) return true;

  // Arrays of valid children are valid
  if (Array.isArray(child)) return child.every(isValidChild);

  // Objects, and other data types are not valid children
  return false;
};

export const LinkifyExternal: FC<ComponentProps<typeof Linkify>> = (props) => {
  const { children } = props;
  const sanitizeChildren = isValidChild(children) ? children : JSON.stringify(children);

  return (
    <Linkify {...props} componentDecorator={componentDecorator}>
      {sanitizeChildren}
    </Linkify>
  );
};
